import { render, staticRenderFns } from "./BaseResendOrderDetails.vue?vue&type=template&id=1e06a03c&scoped=true"
import script from "./BaseResendOrderDetails.vue?vue&type=script&lang=js"
export * from "./BaseResendOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./BaseResendOrderDetails.vue?vue&type=style&index=0&id=1e06a03c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06a03c",
  null
  
)

export default component.exports